import { lazy } from 'react';

import type { TabKenh } from './tabRegistry.js';

/**
 * Mục của chính module `channels`. Module khác thêm mục bằng file cùng tên
 * trong thư mục module của mình — xem tabRegistry.ts.
 *
 * Hai tab cũ "Hồ sơ" và "Phân công" nay là **một** mục trong tab "Cài đặt
 * kênh": hồ sơ, người làm kênh, tình trạng kiếm tiền và tài khoản thương hiệu
 * đều là thứ người ta vào đây để **sửa**, không phải để xem.
 */
const channelTabs: TabKenh[] = [
  {
    id: 'ho-so',
    nhom: 'cai-dat',
    label: 'Hồ sơ và người làm kênh',
    order: 10,
    permission: { module: 'channels', level: 'view' },
    component: lazy(() => import('./pages/tabs/TabCaiDatKenh.js')),
  },
];

export default channelTabs;
